import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

/**
 * Adapter y formatter para usar el datepicker de ng-bootstrap sobre controles que
 * guardan la fecha como string 'DD/MM/AAAA', que es el formato que ya manejan los
 * formularios de registro público.
 */

const SEPARATOR = '/';

function pad(value: number): string {
    return `${value}`.padStart(2, '0');
}

function toStruct(text: string): NgbDateStruct {

    if (!text) return null;

    const [day, month, year] = text.split(SEPARATOR).map(part => parseInt(part, 10));

    if (isNaN(day) || isNaN(month) || isNaN(year)) return null;

    return { day, month, year };
}

function toText(date: NgbDateStruct): string {

    if (!date) return '';

    return `${pad(date.day)}${SEPARATOR}${pad(date.month)}${SEPARATOR}${date.year}`;
}

@Injectable()
export class NgbDateStringAdapter extends NgbDateAdapter<string> {

    fromModel(value: string): NgbDateStruct {
        return toStruct(value);
    }

    toModel(date: NgbDateStruct): string {
        return date ? toText(date) : null;
    }
}

@Injectable()
export class NgbDateStringParserFormatter extends NgbDateParserFormatter {

    parse(value: string): NgbDateStruct {
        return toStruct(value?.trim());
    }

    format(date: NgbDateStruct): string {
        return toText(date);
    }
}
